<template>
  <div :style="{
        backgroundImage: `url(${mainBackgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
      }">
    <div>
      <div style="margin: 10px; display: flex; justify-content: space-between; align-items: center; padding-top: 10px; margin-bottom: 20%;">
        <div style="display: flex; justify-content: center; align-items: center; gap: 10px;">
          <p style="margin: 0px; font-weight: 600 !important; font-size: 16px;">Quiz</p>
        </div>
        <p style="text-align: end; margin: 0px; margin-right: 10px; cursor: pointer;" @click="handleBack()">X</p>
      </div>

      <div :style="{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        padding: '10px',
        borderRadius: '8px'
      }">
        <p style="font-size: 12px;">{{ question }}</p>

        <div
          v-for="(option, index) in options"
          :key="index"
          :style="{
            backgroundColor:'#ffffff',
            padding: '10px',
            marginTop: '10px',
            borderRadius: '5px',
            cursor: 'pointer',
            border: selectedOption === index + 1 ? '1px solid #00ff00' : '1px solid #ccc'
          }"
          @click="selectOption(index + 1)"
        >
          <p style="color: black; margin: 0; font-weight: 400; font-size: 12px; cursor: pointer;">{{ option }}</p>
        </div>

        <!-- Next/Done Button -->
        <button
          :style="{
            padding: '10px',
            width: '30%',
            border: 'none',
            backgroundColor: '#c7222a',
            borderRadius: '15px',
            color: '#ffffff',
            cursor: 'pointer',
            marginTop: '20px'
          }"
        >
          {{ isLast ? "Done" : ">" }}
        </button>

        <!-- <div style="margin-top: 10px;">
          <img
            class="img-fluid"
            style="width: 40px; height: 40px; margin-top: 20px;"
            src="@/assets/abcd-logo.png"
            alt="back"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import mainBackgroundImage from "@/assets/flyy_trivia_back.png";
import backgroundImage from "@/assets/back_frame_png.png";

export default {
  name: "new_quiz-details-custom",
  data() {
    return {
      mainBackgroundImage,
      backgroundImage,
      selectedOption: null,
      quizId: null,
      quizTitle: '',
      question: '',
      options: [],
      isLast: false,
    };
  },
  mounted() {
    this.quizId = this.$route.params.id;
    this.quizTitle = this.$route.params.title;
    this.fetchQuizDetails();
  },
  methods: {
    handleBack() {
      const currentUrl = window.location.pathname;
      if (currentUrl === "/play-quiz") {
        this.$store.state.showExitModal = true;
        return;
      }
      this.$router.go(-1);
    },
    selectOption(optionNumber) {
      this.selectedOption = optionNumber;
      // Additional logic (e.g., save answer, go to next) can go here
    },
    fetchQuizDetails() {
      console.log("Quiz ID - - ", this.quizId);

      const url = this.$store.getters.flyyDomain + "/play_quiz/" + this.quizId;
      const headers = this.$store.getters.headers;

      axios
        .get(url, { headers })
        .then((resp) => {
          if (resp.status === 200 && resp.data) {
            const data = resp.data;

            // Handle question and options
            this.question = data && data.question ? data.question : '';
            this.options = data && data.options ? data.options : [];

            // Optionally determine if it's the last question
            this.isLast = data && data.is_last ? true : false;

            // Optionally: set previously selected option
            if (data && data.selected_option_id) {
              this.selectedOption = data.selected_option_id;
            }
          } else {
            console.warn("Unexpected response format", resp);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        });
    },
  },
};
</script>
